import { footerColumns } from "../../../mocks/guaData";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-accent-100" aria-label="页脚">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-xl text-white">
                <i className="ri-search-eye-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">吃瓜研究所</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              吃瓜研究所专注做吃瓜神器等热点工具的客观测评、上手教程与玩法攻略，
              帮你在吃瓜路上不迷路、少踩坑，把每一次热点都吃明白。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line" aria-hidden="true"></i>
              hello@chigua.example.com
            </p>
          </div>

          {footerColumns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.href + l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-accent-200/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © {year} 吃瓜研究所 · 专注于吃瓜神器的测评教程与攻略分享
          </p>
          <div className="flex gap-4">
            <a href="#home" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
              返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}